function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "quiz");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 45.02923,
  y: 494.17018,
  width: 785.45192,
  height: 2.78529,
  fill: "#3f3d56"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 899.86782,
  height: 437.90359,
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M981.41852,153.68489V141.65457H953.74878V120H941.71847v21.65457H121.25075V120H109.22043v21.65457H81.55069v12.03032h27.66974V524.2187H81.55069V536.249h27.66974v21.65457h12.03032V536.249H941.71847v21.65457h12.03031V536.249h27.66974V524.2187H953.74878V153.68489Zm-39.7,370.53381H121.25075V153.68489H941.71847Z",
  transform: "translate(-81.55069 -120)",
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 397.73891,
  y: 57.74553,
  width: 141.88698,
  height: 134.9673,
  fill: "#d0cde1"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 413.86243,
  y: 73.86905,
  width: 109.63994,
  height: 83.84231,
  fill: "#6c63ff"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 437.98851,
  y: 87.64755,
  width: 38.437,
  height: 38.437,
  fill: "#f2f2f2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M534.25342,217.2593v46.67356H580.927V217.2593Zm44.64908,44.649H536.27789V219.28377H578.9025Z",
  transform: "translate(-81.55069 -120)",
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 413.75384,
  y: 166.03325,
  width: 59.63671,
  height: 3.13877,
  fill: "#f2f2f2"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 468.68239,
  cy: 65.59246,
  r: 6.27755,
  fill: "#3f3d56"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 451.25154,
  y: 252.40895,
  width: 141.88698,
  height: 134.9673,
  fill: "#d0cde1"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 467.37506,
  y: 268.53247,
  width: 109.63994,
  height: 83.84231,
  fill: "#6c63ff"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 467.26648,
  y: 362.26606,
  width: 59.63671,
  height: 3.13877,
  fill: "#f2f2f2"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 467.26648,
  y: 371.68238,
  width: 59.63671,
  height: 3.13877,
  fill: "#f2f2f2"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 486.88382,
  cy: 310.47628,
  r: 12.5551,
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 522.19503,
  cy: 310.47628,
  r: 12.5551,
  fill: "#f2f2f2"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 557.50625,
  cy: 310.47628,
  r: 12.5551,
  fill: "#ff6584"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 522.19503,
  cy: 260.25589,
  r: 6.27755,
  fill: "#3f3d56"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 234.10182,
  y: 210.23848,
  width: 141.88698,
  height: 134.9673,
  fill: "#d0cde1"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 250.22534,
  y: 226.362,
  width: 109.63994,
  height: 83.84231,
  fill: "#6c63ff"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 297.7449,
  cy: 278.08168,
  r: 26.61894,
  fill: "#f2f2f2"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M387.14143,418.61352a33.37392,33.37392,0,1,1,33.37392-33.37392A33.41168,33.41168,0,0,1,387.14143,418.61352Zm0-65.53424a32.16033,32.16033,0,1,0,32.16033,32.16032A32.19651,32.19651,0,0,0,387.14143,353.07928Z",
  transform: "translate(-81.55069 -120)",
  fill: "#3f3d56"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 250.11676,
  y: 327.94252,
  width: 59.63671,
  height: 3.13877,
  fill: "#f2f2f2"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 250.11676,
  y: 318.5262,
  width: 83.17752,
  height: 3.13877,
  fill: "#f2f2f2"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 305.04531,
  cy: 218.08542,
  r: 6.27755,
  fill: "#3f3d56"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 78.15325,
  y: 55.33946,
  width: 141.88698,
  height: 134.9673,
  fill: "#d0cde1"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 94.27677,
  y: 71.46299,
  width: 109.63994,
  height: 83.84231,
  fill: "#6c63ff"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 137.30344,
  y: 137.09908,
  width: 23.58659,
  height: 6.98967,
  fill: "#3f3d56"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 108.78832,
  y: 82.67952,
  width: 80.61684,
  height: 2.99557,
  fill: "#3f3d56"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 108.78832,
  y: 92.1655,
  width: 80.61684,
  height: 2.99557,
  fill: "#3f3d56"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 108.78832,
  y: 101.65148,
  width: 80.61684,
  height: 2.99557,
  fill: "#3f3d56"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 108.78832,
  y: 111.13746,
  width: 80.61684,
  height: 2.99557,
  fill: "#3f3d56"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 108.78832,
  y: 120.62344,
  width: 80.61684,
  height: 2.99557,
  fill: "#3f3d56"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 94.16818,
  y: 163.62718,
  width: 59.63671,
  height: 3.13877,
  fill: "#f2f2f2"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 94.16818,
  y: 171.47412,
  width: 83.17752,
  height: 3.13877,
  fill: "#f2f2f2"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  cx: 149.09674,
  cy: 63.1864,
  r: 6.27755,
  fill: "#3f3d56"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M736.34136,263.5099l102.75768,7.55L868.1588,273.195l-1.80455-1.80455,5.45746,78.94095,2.72873,39.47048c.11025,1.59476.22337,3.18935.33075,4.7843.08927,1.326.4544,2.60355-1.11626,2.9308-3.1231.65069-6.375.92164-9.53893,1.32092q-9.64688,1.21743-19.33725,2.04886a490.06,490.06,0,0,1-77.70424.48715q-9.69743-.71021-19.36133-1.80753c-2.396-.27191-5.3699-.374-6.24485-3.06059-.90221-2.77026-1.05707-5.91942-1.46487-8.79368q-2.72528-19.20842-3.71435-38.61375a443.03351,443.03351,0,0,1,2.73037-77.25819q.581-4.70689,1.26884-9.39932c.33136-2.27193-3.14569-3.25277-3.48017-.95945a446.73739,446.73739,0,0,0-4.45859,80.001q.69924,20.07207,3.21363,40.02566.63617,5.03973,1.38148,10.065c.39608,2.66571.49363,5.80938,2.08021,8.10011,1.5307,2.21007,4.1012,2.91906,6.62733,3.25582,3.21513.42861,6.45157.73575,9.67944,1.0507a489.84415,489.84415,0,0,0,80.6337,1.19277q10.14215-.6871,20.24992-1.79435,4.9792-.54577,9.94649-1.19372,2.43128-.31716,4.85969-.656a22.37512,22.37512,0,0,0,4.46666-.77769c3.0408-1.0963,3.03979-4.02934,2.85083-6.76264l-.70285-10.16663-1.40571-20.33328-5.66418-81.93114-.70286-10.16664a1.85761,1.85761,0,0,0-1.80454-1.80454l-102.75768-7.55-29.05976-2.13512c-2.31712-.17025-2.3063,3.43964,0,3.60909Z",
  transform: "translate(-81.55069 -120)",
  fill: "#d0cde1"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M780.37753,306.11775c.51883-1.37759-.78584,1.58957-.13064.27681.17412-.34888.33685-.70156.52146-1.04538a19.938,19.938,0,0,1,1.21978-1.98189c.4429-.63424,1.11587-.87887-.19388.22431a9.44307,9.44307,0,0,0,.76-.88085,22.19276,22.19276,0,0,1,1.95193-1.89242c.49473-.42459,1.43128-.78593-.24435.15444.33133-.186.63882-.46442.95535-.67724q.9737-.65463,2.00847-1.21164.5171-.27856,1.04726-.53188c.60014-.2868,1.59956-.38544-.28989.098.81106-.20751,1.59594-.59126,2.40714-.82152q1.034-.29351,2.09089-.49405c.62942-.11861,1.77166-.029-.37771.02041.38435-.00883.77774-.083,1.16237-.109a21.941,21.941,0,0,1,2.3288-.03489c.38807.015.77324.05348,1.16057.07661,1.28677.07684-1.94745-.35742-.00042.01354a19.65246,19.65246,0,0,1,2.25936.56993,8.60024,8.60024,0,0,0,1.10534.38783l-.99838-.43015q.36739.1596.728.334a20.08614,20.08614,0,0,1,2.08,1.16346c.33359.21337.65269.445.97986.6675,1.0273.6987-1.37676-1.17594.08013.10115q.74146.65,1.42243,1.36522.40885.42883.79486.87871c.43314.50441.76438,1.42567-.139-.22557.82691,1.51148,1.86035,2.88245,2.63913,4.44069.66429,1.32914-.60539-1.65088-.10088-.25161.136.37728.28226.74985.41061,1.13q.38509,1.14075.66457,2.31361c.18657.78308.27792,1.58253.44991,2.36621-.47335-2.15689-.12719-.9093-.08058-.32327q.06361.7997.07673,1.60234.016,1.00139-.04859,2.00226c-.02547.39066-.113.806-.10777,1.196-.0271-2.025.14657-1.01649.02064-.3363a22.68171,22.68171,0,0,1-.56036,2.33448q-.1715.5768-.3741,1.14342-.18006.50261-.37956.9978.58181-1.3554.09275-.25763c-1.99328,3.98659-4.47673,7.70371-6.43726,11.70413a53.40246,53.40246,0,0,0-4.67971,32.16207,7.22166,7.22166,0,0,0,3.31719,4.31382,7.37059,7.37059,0,0,0,5.562.72765c4.06859-1.31665,5.66815-4.86891,5.04146-8.87923-.22076-1.41272.11579,1.25968-.0286-.1628-.06192-.61005-.12384-1.219-.167-1.83078q-.12926-1.83419-.10533-3.6744.02021-1.57609.15156-3.14776a9.3298,9.3298,0,0,1,.18971-1.82894c-.00117.00389-.23251,1.45125-.07532.61815.06487-.34379.11114-.69191.1727-1.03649a44.59427,44.59427,0,0,1,1.79247-6.85428c.17323-.49616.36265-.98575.54522-1.47842.48191-1.30049-.50125,1.044.08123-.21473.51956-1.12281,1.05732-2.2309,1.649-3.31783,2.48482-4.56487,5.29537-8.842,7.1056-13.752a28.85557,28.85557,0,0,0,1.60166-12.0305c-.66969-8.41857-4.23915-16.96036-10.89178-22.411a28.40744,28.40744,0,0,0-25.0969-5.71855A30.00658,30.00658,0,0,0,766.45683,302.28c-1.33341,3.54049,1.47926,8.06787,5.04147,8.87923,4.10613.93524,7.45156-1.25067,8.87923-5.04147Z",
  transform: "translate(-81.55069 -120)",
  fill: "#d0cde1"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M805.59589,392.11633a6,6,0,1,0-6-6,6.06754,6.06754,0,0,0,6,6Z",
  transform: "translate(-81.55069 -120)",
  fill: "#d0cde1"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 39.7895,
  y: 481.98978,
  width: 33.68489,
  height: 33.68489,
  fill: "#6c63ff"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M175.47663,616.42616H134.57355V575.52308h40.90308Zm-39.12469-1.77839h37.34629V577.30148H136.35194Z",
  transform: "translate(-81.55069 -120)",
  fill: "#3f3d56"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M905.026,420.15645l-4.81212,14.43638s-30.0758,34.88792-8.42123,39.70005,24.06064-37.294,24.06064-37.294l6.01516-12.03032Z",
  transform: "translate(-81.55069 -120)",
  fill: "#ffb8b8"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M938.71089,245.71683s-7.2182-1.203-9.62426,27.66973-3.60909,79.4001-3.60909,79.4001L897.8078,423.76554l34.88793,10.82729,16.84244-80.60314Z",
  transform: "translate(-81.55069 -120)",
  fill: "#575a89"
});

var _ref45 = /*#__PURE__*/React.createElement("polygon", {
  points: "841.521 555.199 837.912 578.057 870.394 578.057 869.191 555.199 841.521 555.199",
  fill: "#ffb8b8"
});

var _ref46 = /*#__PURE__*/React.createElement("polygon", {
  points: "946.185 580.463 943.778 611.742 965.433 614.148 965.433 578.057 946.185 580.463",
  fill: "#ffb8b8"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M936.30482,376.8473,908.63509,535.6475l7.21819,144.36382h37.294V548.88085l36.09095-67.36978L1018.111,565.7233l7.21819,140.75473,40.90308-7.2182L1056.608,562.1142s-7.21819-182.86084-14.43639-185.2669S936.30482,376.8473,936.30482,376.8473Z",
  transform: "translate(-81.55069 -120)",
  fill: "#2f2e41"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M926.68057,690.83861s0-12.03032-9.62426-4.81213S895.40174,706.478,895.40174,706.478s-45.71521,25.26366-13.23335,28.87276,52.9334-16.84245,52.9334-16.84245l3.6091,3.6091s19.2485-3.6091,19.2485-8.42122a92.88949,92.88949,0,0,0-1.203-12.03032s-2.5303-20.40612-5.47576-16.21822S931.49269,698.0568,926.68057,690.83861Z",
  transform: "translate(-81.55069 -120)",
  fill: "#2f2e41"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M1048.18678,724.5235s-21.65457-10.82728-26.4667-1.203-8.42122,28.87277-8.42122,28.87277S997.65945,782.269,1025.32918,779.863s26.4667-18.04548,26.4667-21.65457-1.203-12.03032,0-15.63942S1048.18678,724.5235,1048.18678,724.5235Z",
  transform: "translate(-81.55069 -120)",
  fill: "#2f2e41"
});

var _ref50 = /*#__PURE__*/React.createElement("circle", {
  cx: 919.11633,
  cy: 44.51218,
  r: 33.68489,
  fill: "#ffb8b8"
});

var _ref51 = /*#__PURE__*/React.createElement("polygon", {
  points: "896.86 60.753 895.657 104.062 938.966 100.453 938.966 60.753 896.86 60.753",
  fill: "#ffb8b8"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M1022.92311,198.79859s-20.45154,13.23335-26.4667,15.63941-19.24851-9.62425-19.24851-9.62425-3.60909,2.40606-3.60909,4.81212-2.40606,12.03032-2.40606,12.03032L942.32,316.69571l2.40606,67.36978s87.82133,8.42122,97.44558-2.40606-4.81212-166.0184-4.81212-166.0184Z",
  transform: "translate(-81.55069 -120)",
  fill: "#d0cde1"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M1016.908,224.06225s-32.48186,12.03032-43.30915,1.203C973.59881,225.26529,989.23822,228.87438,1016.908,224.06225Z",
  transform: "translate(-81.55069 -120)",
  opacity: 0.1
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M1102.32322,485.12017c-13.23335,8.42122-56.5425,19.24851-56.5425,19.24851s-4.728-101.83661-21.65457-117.89713c-16.83041-15.98826-44.30776-131.25081-19.59744-151.29329a3.70257,3.70257,0,0,1,.34893-.28872l15.63941-36.091s2.40606-3.6091,7.21819,1.203a131.36557,131.36557,0,0,1,10.82729,13.23335l.68581.27667,32.99908,12.95668-13.23335,58.94856S1115.55657,476.69894,1102.32322,485.12017Z",
  transform: "translate(-81.55069 -120)",
  fill: "#575a89"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M1039.24834,213.51164l-9.107,33.40822-25.6126-11.7416a3.70257,3.70257,0,0,1,.34893-.28872l15.63941-36.091s2.40606-3.6091,7.21819,1.203a131.36557,131.36557,0,0,1,10.82729,13.23335Z",
  transform: "translate(-81.55069 -120)",
  opacity: 0.1
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M976.60639,204.21223l-3.6091,40.90308-.19238,1.86469L945.32756,508.57929s-24.06064-8.42123-32.48186-18.04548,19.24851-116.69409,19.24851-116.69409l2.40606-134.73957s21.34178-15.02585,30.06376-23.27871c2.04509-1.92482,3.39263-3.4767,3.62114-4.391C969.3882,206.61829,976.60639,204.21223,976.60639,204.21223Z",
  transform: "translate(-81.55069 -120)",
  fill: "#575a89"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M976.60639,204.21223l-3.6091,40.90308-.19238,1.86469-17.25158-2.4662,9.0107-28.69236c2.04509-1.92482,3.39263-3.4767,3.62114-4.391C969.3882,206.61829,976.60639,204.21223,976.60639,204.21223Z",
  transform: "translate(-81.55069 -120)",
  opacity: 0.1
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M1040.96859,406.9231l-13.23335,12.03031s6.01516,25.26367,13.23335,26.4667c0,0,4.81213-7.21819,6.01516-13.23335s12.03032-12.03031,12.03032-12.03031Z",
  transform: "translate(-81.55069 -120)",
  fill: "#ffb8b8"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M1056.608,224.06225l15.63941,2.40607s51.73037,87.82132,45.71521,119.10015-54.13643,85.41526-54.13643,85.41526l-30.0758-24.06063,44.51218-60.1516L1055.405,274.58959Z",
  transform: "translate(-81.55069 -120)",
  fill: "#575a89"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M966.90608,168.29567s0-29.70655,7.21893-36.458h8.66271s10.1065-14.85328,23.10057-9.45209,34.65086,14.85328,33.20708,29.70655-5.94648,24.45041-5.94648,24.45041-2.40607,0-7.76912-8.07466c-7.16647-10.78991,9.38461-7.42664-12.27218-11.47753s-34.65086-9.45209-37.53843-4.0509S966.90608,168.29567,966.90608,168.29567Z",
  transform: "translate(-81.55069 -120)",
  fill: "#2f2e41"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M982.645,133.85359s1.15374-8.68188,5.90311-10.55126Z",
  transform: "translate(-81.55069 -120)",
  fill: "#2f2e41"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M982.62423,135.63951s-2.40982-8.42015,1.19767-12.03086Z",
  transform: "translate(-81.55069 -120)",
  fill: "#2f2e41"
});

var SvgQuiz = function SvgQuiz(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fd86286a-adcb-4d81-b7ed-f4cd333bf213",
    "data-name": "Layer 1",
    width: 250,
    height: 300,
    viewBox: "0 0 1036.89861 660",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuiz, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quiz.df1cd0cd.svg";
export { ForwardRef as ReactComponent };